import ChevronRight from '@material-ui/icons/ChevronRight';
import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { EmailValidator } from '~domain/validators/core/basic-types/email-validator';
import { EmailFormField } from '~frontend-common/components/form-fields';
import { FormFields, SentryErrorBox } from '~frontend-common/components/ui';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box/box';
import { Button } from '~ui-kit/components/button/button';
import { PageTitle } from './page-title';

interface LoginFormProps {
  isLoading: boolean;
  error: unknown;
  onEmailFilled: (email: string) => void;
}

interface LoginFormValues {
  email?: string;
}

export function LoginForm({ isLoading, error, onEmailFilled }: LoginFormProps) {
  const translator = useTranslator();
  const { tl } = translator;

  const handleEmailFilled = (formData: LoginFormValues) => {
    onEmailFilled(formData.email);
  };

  const handleValidateForm = (values: LoginFormValues) => {
    const validator = new EmailValidator();
    const error = validator.validate(values.email);

    if (error) {
      return { email: tl(error as string) };
    }
  };

  return (
    <Form<LoginFormValues>
      onSubmit={handleEmailFilled}
      validate={handleValidateForm}
      render={({ handleSubmit }: FormRenderProps) => {
        return (
          <FormFields onSubmit={handleSubmit}>
            <PageTitle $mb={5}>{tl('auth.loginForm.title')}</PageTitle>

            {error && <SentryErrorBox error={error} translator={translator} />}

            <EmailFormField
              data-id="input-login-email"
              name="email"
              label={tl('auth.loginForm.email')}
              placeholder={tl('auth.loginForm.email')}
              autoFocus
              autoComplete="username"
              required
            />

            <Box justifyContent="center" mt={3}>
              <Button data-id="btn-login-next" type="submit" isLoading={isLoading} disabled={isLoading} $width="40%">
                {tl('auth.loginForm.nextButton')}
                <ChevronRight />
              </Button>
            </Box>
          </FormFields>
        );
      }}
    />
  );
}
